import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import styled, { css } from 'styled-components';
/**
 * 20px / 24px
 */
const LargeStyles = css `
  ${fonts.matter.regular};
  font-size: 18px;
  letter-spacing: normal;
  line-height: 24px;
  margin-bottom: 16px;

  @media ${from(Device.Tablet)} {
    line-height: 28px;
  }

  @media ${from(Device.DesktopSmall)} {
    font-size: 20px;
    line-height: 30px;
  }

  @media ${from(Device.DesktopLarge)} {
    font-size: 22px;
    line-height: 32px;
  }
`;
/**
 * 16px / 20px
 */
const RegularStyles = css `
  ${fonts.matter.regular};
  font-size: 16px;
  letter-spacing: normal;
  line-height: 24px;
  margin-bottom: 16px;

  @media ${from(Device.DesktopLarge)} {
    font-size: 18px;
    line-height: 26px;
  }
`;
/**
 * 14px / 18px
 */
const SmallStyles = css `
  ${fonts.matter.regular};
  font-size: 14px;
  letter-spacing: normal;
  line-height: 17px;
  margin-bottom: 16px;

  @media ${from(Device.Tablet)} {
    line-height: 22px; 
  }

  @media ${from(Device.DesktopLarge)} {
    font-size: 16px;
    line-height: 24px;
  }
`;
const Paragraph = styled.p `
  ${({ size }) => {
    switch (size) {
        case 'large':
            return LargeStyles;
        case 'regular':
            return RegularStyles;
        case 'small':
            return SmallStyles;
        default:
            break;
    }
}}

  a {
    
    &:focus {
      outline: 1px solid ${brand.sage.sageLight};
    }
  }
`;
export default {
    Paragraph,
    SmallStyles,
    RegularStyles,
    LargeStyles,
};
